<template>
  <div id="dc_mypage">
    <dd-header />
    <div class="wrapper">
      <h1 style="display:none;">マイページ</h1>
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <section>
            <section v-if="isAdmin">
              <div class="input_confirm4">
                <div>会員情報確認</div>
                <dd-corp-confirm
                  ref="dd-corp-confirm"
                  :corpForm="corpForm"
                  :isPrivateUser="isPrivateUser"
                  :isEdit="true"
                />
                <div class="detail_btn6" @click="route('UpdateCorpInput')">修正する</div>
              </div>
            </section>
            <section>
              <div class="input_confirm4">
                <div>アカウント情報</div>
                <ul>
                  <li>
                    <span>メールアドレス：</span>
                    <span>{{accountForm.email}}</span>
                  </li>
                </ul>
                <div class="detail_btn6" @click="route('UpdateAccountInput')">修正する</div>
              </div>
            </section>
            <section>
              <div class="input_confirm4">
                <div>パスワード</div>
                <ul>
                  <li>
                    <span>パスワード：</span>
                    <span>********</span>
                  </li>
                </ul>
                <div class="detail_btn6" @click="route('UpdatePasswordInput')">修正する</div>
              </div>
            </section>
            <section>
              <div class="input_confirm4">
                <div>ユーザー情報</div>
                <dd-user-confirm
                  ref="dd-user-confirm"
                  :userForm="userForm"
                  :isPrivateUser="isPrivateUser"
                  :isEdit="true"
                />
                <div class="detail_btn6" @click="route('UpdateUserInput')">修正する</div>
              </div>
            </section>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {USER_TYPE} from '../constants/TypeEc'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'

import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import CorpConfirm from '../components/user/DcCorpConfirm'
import UserConfirm from '../components/user/DcUserConfirm'
import DcSiteMap from '../components/common/DcSiteMap'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-corp-confirm': CorpConfirm,
    'dd-user-confirm': UserConfirm,
    'dd-loading-modal': LoadingModal,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcUserAccount',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'mypage', key: 'dcMyPage', title: 'マイページ', route: 'DcMyPage'},
        {id: 'dcUserAccount', key: 'dcUserAccount', title: 'アカウント情報', route: 'DcUserAccount'}
      ],
      corpForm: {
        corpName: '',
        corpBranchName: '',
        email: '',
        tel: '',
        fax: '',
        postcd: '',
        state: '',
        city: '',
        street: ''
      },
      accountForm: {
        email: ''
      },
      userForm: {
        corpType: '',
        corpDept: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        userType: '',
        infosrc: '',
        recvInfo: '',
        consent: ''
      }
    }
  },
  computed: {
    isPrivateUser: function () {
      if (!this.userForm) return false
      if (this.userForm.userLevel === 3) {
        return true
      }
      return false
    },
    isAdmin: function () {
      if (this.userForm.userType === USER_TYPE.DC_ADMIN.code) {
        return true
      }
      return false
    }
  },
  methods: {
    route: function (name, params) {
      this.$router.push({
        name: name,
        query: params
      })
    },
    fetchData: function () {
      let payload = {
      }
      axios.post(DC_URL.USER + '/edit', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.$set(this.corpForm, 'corpName', response.data.data.corpName)
            this.$set(this.corpForm, 'corpBranchName', response.data.data.branch)
            this.$set(this.corpForm, 'email', response.data.data.email)
            this.$set(this.corpForm, 'tel', response.data.data.tel)
            this.$set(this.corpForm, 'fax', response.data.data.fax)
            this.$set(this.corpForm, 'postcd', response.data.data.postcd)
            this.$set(this.corpForm, 'state', response.data.data.state)
            this.$set(this.corpForm, 'city', response.data.data.city)
            this.$set(this.corpForm, 'street', response.data.data.street)

            this.$set(this.accountForm, 'email', response.data.data.userList[0].email)

            this.$set(this.userForm, 'corpType', response.data.data.userList[0].corpType)
            this.$set(this.userForm, 'corpDept', response.data.data.userList[0].userDepartment)
            this.$set(this.userForm, 'userLastName', response.data.data.userList[0].userLastName)
            this.$set(this.userForm, 'userFirstName', response.data.data.userList[0].userFirstName)
            this.$set(this.userForm, 'userLastNameKana', response.data.data.userList[0].userLastNameKana)
            this.$set(this.userForm, 'userFirstNameKana', response.data.data.userList[0].userFirstNameKana)
            this.$set(this.userForm, 'userType', response.data.data.userList[0].userType)
            this.$set(this.userForm, 'userLevel', response.data.data.userList[0].userLevel)
            this.$set(this.userForm, 'infosrc', response.data.data.userList[0].infosrc)
            this.$set(this.userForm, 'inviteCode', response.data.data.userList[0].inviteCode)
            this.$set(this.userForm, 'recvInfo', response.data.data.userList[0].recvInfo)
            App.setLocalStorage(DC_STORAGE_KEY.CORP_DATA, this.corpForm)
            App.setLocalStorage(DC_STORAGE_KEY.ACCOUNT_DATA, this.accountForm)
            App.setLocalStorage(DC_STORAGE_KEY.USER_DATA, this.userForm)
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    }
  },
  mounted: function () {
  },
  created: function () {
    this.fetchData()
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcUserAccount.vue